import ActivationInfoModule from '../info'
import ActivationPersonalDataModule from './personalData'
import ActivationTariffOptionsModule from '../tariffOptions'
import ActivationTopUpModule from './topUp'
import ActivationPaymentModule from './payment'
import { ActivationSubmitModule } from './submit'
import ActivationTariffsModule from '../tariffs'

const ActivationModule = {
  namespaced: true,
  modules: {
    info: ActivationInfoModule,
    tariff: ActivationTariffsModule,
    tariffOptions: ActivationTariffOptionsModule,
    topUp: ActivationTopUpModule,
    personalData: ActivationPersonalDataModule,
    payment: ActivationPaymentModule,
    submit: ActivationSubmitModule
  },
  state: {
    view: 'activationInfo',
    sum: 0
  },
  actions: {
    selectProducts  ({ commit, state, getters, rootGetters }, { tariff, tariffOptions, nextStep }) {
      commit('activation/tariff/storeTariff', tariff, { root: true })
      commit('activation/tariffOptions/storeTariffOptions', tariffOptions, { root: true })
      commit('goToStep', nextStep)
    }
  },
  mutations: {
    goToStep (state, step) {
      state.view = step
    },
    setPrice (state, sum) {
      state.sum = sum
    }
  },
  getters: {
    showActivationView: state => {
      return state.view
    },
    summedUpPrice: state => {
      return state.sum
    }
  }
}

export {
  ActivationModule
}
